import * as React from "react";

import { useReactGiftCardInitialState } from "../react-gift-card-initial-state-provider";

interface AboutContentConsumerInterface {
  content: string | null | undefined;
}

const defaultValue = {};

const AboutContentContext = React.createContext(
  defaultValue as unknown as AboutContentConsumerInterface
);

export const AboutContentProvider: React.FunctionComponent = (props) => {
  const { initialState } = useReactGiftCardInitialState();

  const [content, setContent] = React.useState<string | null>(null);

  React.useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const contentId = "giftcard-purchase-page-about";

      const contentQuery = `{
        cmsBlocks(identifiers: "${contentId}") {
          items {
            identifier
            title
            content
          }
        }
      }`;

      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Store", initialState.store_code);

      const request = new Request("/graphql", {
        method: "POST",
        headers,
        body: JSON.stringify({ query: contentQuery }),
      });

      const contentQueryResponse = await fetch(request);

      const contentQueryResponseJson = await contentQueryResponse?.json();

      let content = null;
      if (
        contentQueryResponseJson?.data &&
        contentQueryResponseJson?.data?.cmsBlocks?.items?.length > 0
      ) {
        content = contentQueryResponseJson.data.cmsBlocks.items[0]?.content;
      }

      setContent(content);
    } catch (error) {
      console.error(error);
      setContent(null);
    }
  };

  return (
    <AboutContentContext.Provider
      value={{
        content,
      }}
    >
      {props.children}
    </AboutContentContext.Provider>
  );
};

export const useAboutContent = () => React.useContext(AboutContentContext);
